module.exports = __webpack_public_path__ + "static/media/4.1c10d50e.jpg";